// extracted by mini-css-extract-plugin
export default {"container":"home_container__VyeXg","square":"home_square__C41By","innerContent":"home_innerContent__OCJwd"};